import WalletPage from "@/screens/wallet";

export default function WalletIndex() {
  return <WalletPage />;
}
